export const RESIGNATION_REQUEST_PATH =
  "/requests/resignation/:requestId?" as const;
